// extracted by mini-css-extract-plugin
module.exports = {"activeOption":"_j8","option":"_j9","phone":"_ka","value":"_kb","text":"_kc","label":"_kd","list":"_ke","centerMenu":"_kf","active":"_kg"};